<template>
  <div class="body-container import-order">
    <div class="row">
      <span class="label">投保人身份证</span>
      <input type="text" maxlength="30" placeholder="请输入" v-model="formData.idCard">
    </div>
    <div class="row">
      <span class="label">投保人手机号</span>
      <input type="tel" placeholder="请输入" v-model="formData.mobile">
    </div>
    <div class="row">
      <span class="label">验证码</span>
      <input type="text" placeholder="请输入" v-model="formData.code">
      <div class="code-btn blue" @click="getCodeAjax(formData.mobile);" v-if="codeIndex==CODE_SIZE">获取验证码</div>
      <div class="code-btn" v-else>{{codeIndex}}S</div>
    </div>
    <div class="bottom-box">
      <van-button class="btn" type="info" @click="save">保存</van-button>
    </div>
  </div>
</template>
<script>
import {common,codeTools} from "@/api/mixins";
//当前实例组件
export default {
  mixins: [common,codeTools],
  data: () => ({
    id:"",
    formData:{},
  }),
  mounted() {

  },
  methods: {
    yz(){
      if(!this.formData.idCard) {
        this.$notice.msg("请输入投保人身份证号");
        return false;
      }
      if(!this.$regulars.issfz(this.formData.idCard)) {
        this.$notice.msg("请输入正确的投保人身份证号");
        return false;
      }
      if(!this.formData.mobile){
        this.$notice.msg("请输入投保人手机号");
        return false;
      }
      if(!this.$regulars.isPhone(this.formData.mobile)){
        this.$notice.msg("请输入正确的投保人手机号");
        return false;
      }
      if(!this.formData.code){
        this.$notice.msg("请输入验证码");
        return false;
      }
      return true;
    },
    save(){
      if(!this.yz()){
        return;
      }
      this.$http({
        type: "PUT",
        url: "/api/bplat/bindPolicy",
        data: this.formData
      }).then(res=>{
        this.$notice.msg("关联成功");
        history.back()
      })
    },
  },
};
</script>
<style lang="scss" scoped>
@import "./importOrder.scss";
</style>
